import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 142.11 112.19",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("circle", {
        cx: "134.37",
        cy: "104.45",
        r: "7.73"
      }),
      _createElementVNode("path", { d: "M48.6 45.46H24.64c-2.49 0-4.51 2.02-4.51 4.51v5.62c0 5.85 4.76 10.6 10.6 10.6h14.05c2.88 0 5.22-2.34 5.22-5.22v-14.1c0-.77-.63-1.41-1.41-1.41Z" }),
      _createElementVNode("path", { d: "M9.86 0C4.42 0 0 4.42 0 9.86v88.82c0 7.22 5.86 13.08 13.08 13.08h88.59c13.79 0 24.97-11.18 24.97-24.97V0zm105.49 50.04c0 3.83-1.08 6.69-2.99 8.33-1.36 1.17-3.31 1.93-7.07 1.93H85.64c-.5-2.03.64-8.73 8.2-9.31h9.44c.74 0 1.35-.06 1.81-.18s.81-.37 1.06-.74c.25-.38.37-.91.37-1.62 0-.64-.12-1.14-.37-1.49s-.59-.59-1.04-.72q-.66-.18-1.62-.18H82.2c-.96 0-1.76.2-2.42.61s-.98 1.18-.98 2.31v13.94c0 1.14.33 1.91.98 2.31.65.41 1.46.61 2.42.61h31.55c-.03 3.07-2.68 9.3-9.25 9.3H81.67c-2.3 0-4.33-.43-6.09-1.3s-3.13-2.19-4.12-3.96-1.49-3.95-1.49-6.54V50.99c-.01-3-2.44-5.42-5.44-5.42h-.26c-2.93 0-5.31 2.32-5.43 5.21v10.18c0 7.75-6.31 14.06-14.06 14.06H30.73c-10.72 0-19.45-8.72-19.45-19.45v-5.62c0-7.36 5.99-13.35 13.35-13.35h23.96c2.69 0 5.14 1.05 6.97 2.76 2.41-1.5 5.43-2.62 8.71-2.62h.26c3.26 0 6.27 1.11 8.67 2.97q3.18-2.97 8.46-2.97h21.98c3.76 0 6.64.91 8.67 2.74 2.02 1.83 3.03 4.67 3.03 8.53v2.02Z" })
    ], -1)
  ])))
}
export default { render: render }